import { graphql } from '@api/mesa'
import { useLoggedInQuery } from '@/src/common/gql/MesaGql'

export const SURVEYS_GET_AVAILABLE = graphql(`
  query SurveysGetAvailable {
    availableSurveys {
      items {
        id
      }
    }
  }
`)

export const useGetAvailableSurveys = () => {
  const { data, loading, error, refetch } = useLoggedInQuery(SURVEYS_GET_AVAILABLE, {
    fetchPolicy: 'cache-and-network',
  })

  return {
    data,
    loading,
    error,
    refetch,
    query: SURVEYS_GET_AVAILABLE,
  }
}
